// extracted by mini-css-extract-plugin
export default {"tabGroup":"_6EFdPUZfSZoN508ayln3qE","badge":"_2obaPxEOlr01ReTl7wq586"};